import ConfigForm from './ConfigForm.jsx';

const SCHEMA = [
  { key: 'body', label: 'Body (HTML)', kind: 'textarea', rows: 6 },
  { key: 'style', label: 'Style', kind: 'text' },
  { key: 'level', label: 'Level', kind: 'text' },
];

export default function MarkupConfig({ field, onConfigChange }) {
  return <ConfigForm schema={SCHEMA} config={field.config} onConfigChange={onConfigChange} />;
}
